var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShorts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A7DBE"
    },
    d: "M52.967,8.828v52.966h406.069V8.828c0-4.875-3.953-8.828-8.828-8.828H61.794 C56.919,0,52.967,3.953,52.967,8.828z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.863,
    style: {
      fill: "#4D71B4"
    },
    width: 17.655,
    height: 61.793
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6487C8"
    },
    d: "M449.516,52.966h-69.929V8.828c0-4.875-3.948-8.828-8.828-8.828c-4.879,0-8.828,3.953-8.828,8.828 v44.138H150.07V8.828c0-4.875-3.948-8.828-8.828-8.828s-8.828,3.953-8.828,8.828v44.138H62.486 c-10.017,0-18.027,8.324-17.642,18.334l16.623,432.212c0.182,4.74,4.077,8.489,8.821,8.489h150.723c4.748,0,8.646-3.756,8.821-8.501 l8.21-221.67c0.352-9.49,8.147-17.002,17.643-17.002h0.629c9.496,0,17.291,7.512,17.643,17.002l8.21,221.67 c0.175,4.745,4.073,8.501,8.821,8.501h150.723c4.744,0,8.639-3.748,8.821-8.489l16.623-432.212 C467.543,61.29,459.533,52.966,449.516,52.966z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A7DBE"
    },
    d: "M48.139,156.966h31.31v-51.034c0-4.875-3.953-8.828-8.828-8.828H45.837L48.139,156.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A7DBE"
    },
    d: "M221.012,512c4.748,0,8.646-3.756,8.821-8.501l0.993-26.809H60.436l1.032,26.822 c0.182,4.74,4.077,8.489,8.821,8.489H221.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A7DBE"
    },
    d: "M281.176,476.69l0.993,26.809c0.175,4.745,4.073,8.501,8.821,8.501h150.723 c4.744,0,8.639-3.748,8.821-8.489l1.032-26.822H281.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D71B4"
    },
    cx: 256.001,
    cy: 26.483,
    r: 8.828
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D71B4"
    },
    d: "M459.036,176.552h4.074l1.018-26.483h-5.092c-24.376,0-44.138-19.762-44.138-44.138V52.966h-26.483 v52.966C388.415,144.934,420.033,176.552,459.036,176.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D71B4"
    },
    d: "M52.967,176.552h-4.074l-1.018-26.483h5.092c24.376,0,44.138-19.762,44.138-44.138V52.966h26.483 v52.966C123.587,144.934,91.969,176.552,52.967,176.552z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5A7DBE"
    },
    d: "M256.001,52.966h-8.828h-8.828v226.637c1.393-8.399,8.609-14.775,17.341-14.775h0.314V220.69h8.828 c4.875,0,8.828-3.953,8.828-8.828V52.966H256.001z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShorts);
export default __webpack_public_path__ + "static/media/shorts.cf7b21b5c6d2b6faa63b8643be344808.svg";
export { ForwardRef as ReactComponent };